  // Scroll an element into view inside its own scrollable rail ONLY.
  // Never scrolls the document: scrollIntoView({block:'nearest'}) still yanks the
  // page when the gallery is partly above the viewport (e.g. tapping a size).
  function scrollWithinRail(el, align, smooth) {
    if (!el) return;
    var c = el.parentElement;
    while (c && c !== document.body && c !== document.documentElement) {
      var s = getComputedStyle(c);
      var ox = /(auto|scroll)/.test(s.overflowX) && c.scrollWidth > c.clientWidth + 1;
      var oy = /(auto|scroll)/.test(s.overflowY) && c.scrollHeight > c.clientHeight + 1;
      if (ox || oy) {
        var er = el.getBoundingClientRect();
        var cr = c.getBoundingClientRect();
        var opts = { behavior: smooth ? 'smooth' : 'auto' };
        if (ox) {
          opts.left = (er.left - cr.left);
          if (align === 'center') opts.left -= (c.clientWidth - el.offsetWidth) / 2;
        }
        if (oy) {
          opts.top = (er.top - cr.top);
          if (align === 'center') opts.top -= (c.clientHeight - el.offsetHeight) / 2;
        }
        c.scrollBy(opts);
        return;
      }
      c = c.parentElement;
    }
  }

/**
 * Untamed v2.1 - Product Page JavaScript
 * ============================================
 * Handles variant selection, option availability, and media gallery interactions.
 */

(function() {
  'use strict';

  /**
   * Product Variant Selector Class
   * Handles variant selection, option availability updates, and UI synchronization
   */
  class ProductVariantSelector {
    constructor(config) {
      this.variants = config.variants || [];
      this.options = config.options || [];
      this.moneyFormat = config.moneyFormat || '${{amount}}';
      this.currentVariantId = config.currentVariantId;
      this.sectionId = config.sectionId || null;
      
      // Get container (scoped to section if sectionId provided)
      this.container = this.sectionId 
        ? document.querySelector(`[data-section-id="${this.sectionId}"]`)
        : document;
      
      if (!this.container) return;
      
      // Initialize selected options from current variant
      this.selectedOptions = {};
      const currentVariant = this.variants.find(v => v.id === this.currentVariantId);
      this.options.forEach((option, index) => {
        const optionKey = 'option' + (index + 1);
        this.selectedOptions[option.name] = currentVariant ? currentVariant[optionKey] : option.values[0];
      });
      
      this.init();
    }
    
    init() {
      this.syncUIState();
      this.updateOptionAvailability();
      this.bindEvents();
    }
    
    syncUIState() {
      // Sync button active states to match current variant
      Object.entries(this.selectedOptions).forEach(([optionName, optionValue]) => {
        const btn = this.container.querySelector(`[data-option-name="${optionName}"][data-option-value="${optionValue}"]`);
        if (btn) {
          const container = btn.closest('.product-variants-block__pills, .product-variants-block__swatches');
          if (container) {
            container.querySelectorAll('button').forEach(b => b.classList.remove('active'));
          }
          btn.classList.add('active');
          
          const label = btn.closest('.product-variants-block__option')?.querySelector('.product-variants-block__selected-value');
          if (label) label.textContent = ' ' + optionValue.replace(/Charcoal Gr[ea]y/gi, 'Dark Brown');
        }
      });
    }
    
    bindEvents() {
      // Pills and swatches
      this.container.querySelectorAll('.product-variants-block__pill, .product-variants-block__swatch').forEach(btn => {
        btn.addEventListener('click', (e) => this.handleOptionClick(e));
      });
      
      // Dropdowns
      this.container.querySelectorAll('.product-variants-block__dropdown').forEach(dropdown => {
        dropdown.addEventListener('select:change', (e) => this.handleDropdownChange(e, dropdown));
      });
    }
    
    handleOptionClick(e) {
      const btn = e.currentTarget;
      if (btn.disabled) return;
      
      const optionName = btn.dataset.optionName;
      const optionValue = btn.dataset.optionValue;
      
      // Update active state
      const container = btn.closest('.product-variants-block__pills, .product-variants-block__swatches');
      if (container) {
        container.querySelectorAll('button').forEach(b => b.classList.remove('active'));
      }
      btn.classList.add('active');
      
      // Update label
      const label = btn.closest('.product-variants-block__option')?.querySelector('.product-variants-block__selected-value');
      if (label) label.textContent = ' ' + optionValue;
      
      // Update selection and find variant
      this.selectedOptions[optionName] = optionValue;
      this.updateOptionAvailability();
      
      const variant = this.findVariant();
      if (variant) {
        this.updateVariant(variant);
      }
    }
    
    handleDropdownChange(e, dropdown) {
      const optionName = dropdown.dataset.optionName;
      const optionValue = e.detail.value;
      
      const label = dropdown.closest('.product-variants-block__option')?.querySelector('.product-variants-block__selected-value');
      if (label) label.textContent = ' ' + optionValue;
      
      this.selectedOptions[optionName] = optionValue;
      this.updateOptionAvailability();
      
      const variant = this.findVariant();
      if (variant) {
        this.updateVariant(variant);
      }
    }
    
    findVariant() {
      return this.variants.find(variant => {
        return this.options.every((option, index) => {
          const optionKey = 'option' + (index + 1);
          return variant[optionKey] === this.selectedOptions[option.name];
        });
      });
    }
    
    updateOptionAvailability() {
      this.options.forEach((option, optionIndex) => {
        const optionKey = 'option' + (optionIndex + 1);
        
        option.values.forEach(value => {
          // Check if ANY variant with this option value is available
          // considering the OTHER currently selected options
          const isAvailable = this.variants.some(variant => {
            if (variant[optionKey] !== value) return false;
            if (!variant.available) return false;
            
            // Check if matches all OTHER selected options
            return this.options.every((otherOption, otherIndex) => {
              if (otherIndex === optionIndex) return true;
              const otherKey = 'option' + (otherIndex + 1);
              return variant[otherKey] === this.selectedOptions[otherOption.name];
            });
          });
          
          // Find and update button
          const btn = this.container.querySelector(
            `.product-variants-block__pill[data-option-name="${option.name}"][data-option-value="${value}"],
             .product-variants-block__swatch[data-option-name="${option.name}"][data-option-value="${value}"]`
          );
          
          if (btn) {
            if (btn.classList.contains('product-variants-block__swatch')) {
              // Colour swatches are never faded or disabled — clicking a colour
              // always works, and the size pills below show which combinations
              // are sold out. ATC button flips to "Sold Out" when the specific
              // variant is unavailable.
            } else {
              btn.disabled = !isAvailable;
            }
          }
        });
      });
    }
    
    formatMoney(cents) {
      if (window.formatMoney) {
        return window.formatMoney(cents, this.moneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    }
    
    updateVariant(variant, opts = {}) {
      const isAvailable = variant.available === true;
      
      // Update hidden variant inputs
      this.container.querySelectorAll('input[name="id"], [data-variant-id]').forEach(input => {
        input.value = variant.id;
      });
      
      // Update price displays
      this.container.querySelectorAll('[id^="product-price-current"]').forEach(el => {
        el.textContent = this.formatMoney(variant.price);
        el.classList.toggle('product-price-block__current--on-sale', 
          variant.compare_at_price && variant.compare_at_price > variant.price);
      });
      
      this.container.querySelectorAll('[id^="product-price-compare"]').forEach(el => {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          el.textContent = this.formatMoney(variant.compare_at_price);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
      
      // Update add to cart buttons
      this.container.querySelectorAll('.product-add-to-cart-block__btn').forEach(btn => {
        const btnText = btn.querySelector('[data-add-to-cart-text]');
        btn.disabled = !isAvailable;
        if (btnText) btnText.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
      });
      
      // Update buy now buttons
      this.container.querySelectorAll('.shopify-payment-button button').forEach(btn => {
        btn.disabled = !isAvailable;
      });
      this.container.querySelectorAll('.product-add-to-cart-block__dynamic-checkout').forEach(container => {
        container.style.display = isAvailable ? '' : 'none';
      });
      
      // Update URL
      if (!this.sectionId) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      
      // Update media gallery
      if (variant.featured_media) {
        document.dispatchEvent(new CustomEvent('product:media-change', {
          detail: { mediaId: variant.featured_media.id.toString(), sectionId: this.sectionId, instant: !!opts.instantScroll }
        }));
      }
      
      // Update stock block
      this.updateStockBlock(variant, isAvailable);
      
      // Dispatch event for other blocks
      window.dispatchEvent(new CustomEvent('variant:changed', {
        detail: { variant: variant, selectedOptions: { ...this.selectedOptions } }
      }));
    }
    
    updateStockBlock(variant, isAvailable) {
      this.container.querySelectorAll('.product-stock-block').forEach(stockBlock => {
        stockBlock.classList.remove('product-stock-block--in-stock', 'product-stock-block--low-stock', 'product-stock-block--out-of-stock');
        
        const message = stockBlock.querySelector('.product-stock-block__text');
        const barFill = stockBlock.querySelector('.product-stock-block__bar-fill');
        const threshold = parseInt(stockBlock.dataset.lowStockThreshold) || 5;
        const maxFillPercent = 80;
        let progressPercent = 0;
        
        if (!isAvailable) {
          stockBlock.classList.add('product-stock-block--out-of-stock');
          if (message) message.textContent = 'Out of Stock';
          progressPercent = 0;
        } else if (variant.inventory_management !== 'shopify') {
          stockBlock.classList.add('product-stock-block--in-stock');
          if (message) message.textContent = 'In Stock';
          progressPercent = maxFillPercent;
        } else if (variant.inventory_quantity <= 0) {
          stockBlock.classList.add('product-stock-block--in-stock');
          if (message) message.textContent = 'In Stock';
          progressPercent = maxFillPercent;
        } else if (variant.inventory_quantity <= threshold) {
          stockBlock.classList.add('product-stock-block--low-stock');
          if (message) message.textContent = `Only ${variant.inventory_quantity} left!`;
          progressPercent = Math.min((variant.inventory_quantity / threshold) * maxFillPercent, maxFillPercent);
        } else {
          stockBlock.classList.add('product-stock-block--in-stock');
          if (message) message.textContent = 'In Stock';
          progressPercent = maxFillPercent;
        }
        
        if (barFill) {
          barFill.style.setProperty('--progress', progressPercent + '%');
        }
      });
    }
  }

  /**
   * Product Media Gallery Class
   * Handles thumbnail navigation, swipe gestures, and media switching
   */
  class ProductMediaGallery {
    constructor(container) {
      this.container = container;
      this.id = container.id;
      this.layout = container.dataset.layout || 'collage';
      this.mobileLayout = container.dataset.mobileLayout || 'thumbnail';
      this.enableLightbox = container.dataset.enableLightbox === 'true';
      
      this.thumbnailsScrolls = container.querySelectorAll('.product-media-gallery__thumbnails-scroll');
      this.desktopFeatured = container.querySelector('.product-media-gallery__featured');
      this.thumbnails = container.querySelectorAll('.product-media-gallery__thumbnail');
      
      // Mobile carousel elements
      this.carouselSlider = container.querySelector('.product-media-gallery__carousel-slider');
      this.carouselItems = container.querySelectorAll('.product-media-gallery__carousel-item');
      
      this.currentIndex = 0;
      this.allMedia = [];
      
      // Build media data from thumbnails
      this.buildMediaData();
      
      this.init();
    }
    
    buildMediaData() {
      // Extract media info from each thumbnail
      this.thumbnails.forEach((thumb, index) => {
        const img = thumb.querySelector('.product-media-gallery__thumbnail-image');
        const mediaType = thumb.dataset.mediaType || 'image';

        if (img) {
          const thumbSrc = img.src;
          const highResSrc = thumbSrc.replace(/width=\d+/, 'width=1200');
          const lightboxSrc = thumbSrc.replace(/width=\d+/, 'width=2400');

          var mediaEntry = {
            index: index,
            id: thumb.dataset.mediaId,
            type: mediaType,
            src: highResSrc,
            srcset: `${thumbSrc.replace(/width=\d+/, 'width=600')} 600w, ${thumbSrc.replace(/width=\d+/, 'width=900')} 900w, ${highResSrc} 1200w`,
            lightboxSrc: lightboxSrc,
            alt: img.alt || ''
          };

          // For videos, find the video source from the carousel item
          if (mediaType === 'video') {
            var carouselItem = this.carouselItems[index];
            if (carouselItem) {
              var video = carouselItem.querySelector('video');
              if (video) {
                var source = video.querySelector('source');
                mediaEntry.videoSrc = source ? source.src : '';
                mediaEntry.videoElement = video;
              }
            }
          }

          this.allMedia.push(mediaEntry);
        }
      });
    }
    
    init() {
      this.bindThumbnailClicks();
      this.bindSwipeGestures();
      this.bindVariantMediaChange();

      if (this.enableLightbox) {
        this.bindLightbox();
      }

    }

    bindThumbnailClicks() {
      if (!this.thumbnailsScrolls.length) return;

      this.thumbnailsScrolls.forEach((thumbnailsScroll) => {
        thumbnailsScroll.addEventListener('click', (e) => {
          const thumb = e.target.closest('.product-media-gallery__thumbnail');
          if (!thumb) return;

          const index = parseInt(thumb.dataset.index);
          this.goToSlide(index);
        });
      });
    }
    
    bindSwipeGestures() {
      if (!this.carouselSlider) return;
      
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;
      const minSwipeDistance = 50;
      
      this.carouselSlider.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });
      
      this.carouselSlider.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;
        
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;
        
        // Only handle horizontal swipes
        if (Math.abs(deltaX) < minSwipeDistance || Math.abs(deltaY) > Math.abs(deltaX)) {
          return;
        }
        
        if (deltaX < 0) {
          // Swipe left - next
          this.next();
        } else {
          // Swipe right - previous
          this.prev();
        }
      }, { passive: true });
    }
    
    bindVariantMediaChange() {
      document.addEventListener('product:media-change', (e) => {
        const mediaId = e.detail.mediaId;
        const thumb = this.container.querySelector(`[data-media-id="${mediaId}"]`);
        
        if (thumb && thumb.dataset.index) {
          this.goToSlide(parseInt(thumb.dataset.index));
        }
      });
    }
    
    bindLightbox() {
      // Claim the lightbox so the legacy product-media-gallery.js implementation
      // cannot bind a second overlay on top of this one.
      window.__productLightboxBound = true;
      this.container.querySelectorAll('.product-media-gallery__image').forEach(img => {
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', () => {
          const lightboxSrc = img.dataset.lightboxSrc || img.src;
          this.openLightbox(lightboxSrc, img.alt);
        });
      });
    }
    
    goToSlide(index) {
      const maxIndex = Math.max(this.thumbnails.length, this.carouselItems.length);
      if (index < 0 || index >= maxIndex) return;
      
      this.currentIndex = index;
      
      // Update active thumbnail
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
      });
      
      // Scroll thumbnail into view
      const activeThumb = this.thumbnails[index];
      if (activeThumb) {
        scrollWithinRail(activeThumb, 'center', true);
      }
      
      // Update mobile carousel
      this.updateMobileCarousel(index);
      
      // Update desktop featured image
      this.updateDesktopFeaturedImage(index);
    }
    
    updateMobileCarousel(index) {
      if (!this.carouselItems.length) return;

      // Pause all videos first
      this.carouselItems.forEach((item) => {
        var video = item.querySelector('video');
        if (video) { video.pause(); }
      });

      // Update active state on carousel items (CSS handles opacity/visibility)
      this.carouselItems.forEach((item, i) => {
        if (i === index) {
          item.classList.add('is-active');
          item.classList.remove('is-leaving');
          // Load deferred carousel images (data-src) on slide activation
          item.querySelectorAll('img[data-src]').forEach(function(img) {
            if (img.dataset.srcset) img.srcset = img.dataset.srcset;
            img.src = img.dataset.src;
            img.removeAttribute('loading');
            delete img.dataset.src;
            delete img.dataset.srcset;
          });
          // Fallback: force-load any remaining lazy images hidden under visibility:hidden
          item.querySelectorAll('img').forEach(function(img) {
            if (img.getAttribute('loading') === 'lazy' && (!img.complete || img.naturalWidth === 0)) {
              img.removeAttribute('loading');
              var s = img.getAttribute('src'); img.src = ''; img.src = s;
            }
          });
          // Play video if this item contains one
          var video = item.querySelector('video');
          if (video) { video.currentTime = 0; video.play().catch(function(){}); }
        } else if (item.classList.contains('is-active')) {
          item.classList.add('is-leaving');
          item.classList.remove('is-active');
          setTimeout(() => item.classList.remove('is-leaving'), 500);
        } else {
          item.classList.remove('is-active', 'is-leaving');
        }
      });
    }
    
    updateDesktopFeaturedImage(index) {
      if (!this.desktopFeatured || !this.allMedia[index]) return;

      const media = this.allMedia[index];
      const image = this.desktopFeatured.querySelector('.product-media-gallery__featured-image');
      const wrapper = this.desktopFeatured.querySelector('.product-media-gallery__image-wrapper') || this.desktopFeatured;

      // Remove any previously injected video
      var existingVideo = wrapper.querySelector('.product-media-gallery__inline-video');
      if (existingVideo) { existingVideo.remove(); }

      // Show image, hide video state
      if (image) { image.style.display = ''; }

      if (media.type === 'video' && media.videoSrc) {
        // Hide the image and show a video player
        if (image) { image.style.display = 'none'; }
        var video = document.createElement('video');
        video.className = 'product-media-gallery__inline-video';
        video.src = media.videoSrc;
        video.controls = true;
        video.autoplay = true;
        video.muted = true;
        video.playsInline = true;
        // contain, not cover: the shoot videos are 9:16 and the gallery box is
        // 1:1, so cover was cropping ~44% off the top and bottom of the frame.
        video.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;background:#F6F6F4;border-radius:inherit;';
        wrapper.appendChild(video);
        video.play().catch(function(){});

        this.desktopFeatured.dataset.mediaId = media.id;
        this.desktopFeatured.dataset.index = index;
      } else if (image && media.type === 'image') {
        // Animate transition with GSAP if available
        if (typeof gsap !== 'undefined') {
          gsap.to(image, {
            opacity: 0,
            scale: 0.98,
            duration: 0.15,
            ease: 'power2.in',
            onComplete: () => {
              image.src = media.src;
              image.srcset = media.srcset;
              image.alt = media.alt;
              image.dataset.lightboxSrc = media.lightboxSrc;
              this.desktopFeatured.dataset.mediaId = media.id;
              this.desktopFeatured.dataset.index = index;
              gsap.to(image, {
                opacity: 1,
                scale: 1,
                duration: 0.2,
                ease: 'power2.out'
              });
            }
          });
        } else {
          image.src = media.src;
          image.srcset = media.srcset;
          image.alt = media.alt;
          image.dataset.lightboxSrc = media.lightboxSrc;
          this.desktopFeatured.dataset.mediaId = media.id;
          this.desktopFeatured.dataset.index = index;
        }
      }
    }
    
    next() {
      const newIndex = this.currentIndex < this.thumbnails.length - 1 
        ? this.currentIndex + 1 
        : 0;
      this.goToSlide(newIndex);
    }
    
    prev() {
      const newIndex = this.currentIndex > 0 
        ? this.currentIndex - 1 
        : this.thumbnails.length - 1;
      this.goToSlide(newIndex);
    }
    
    openLightbox(src, alt) {
      // Create lightbox overlay
      const overlay = document.createElement('div');
      overlay.className = 'product-lightbox';
      overlay.innerHTML = `
        <div class="product-lightbox__backdrop"></div>
        <div class="product-lightbox__content">
          <img src="${src}" alt="${alt || ''}" class="product-lightbox__image">
          <button type="button" class="product-lightbox__close" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </button>
        </div>
      `;
      
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';
      
      // Animate in with GSAP if available
      if (typeof gsap !== 'undefined') {
        gsap.fromTo(overlay, { opacity: 0 }, { opacity: 1, duration: 0.3 });
        gsap.fromTo(overlay.querySelector('.product-lightbox__image'), 
          { scale: 0.9, opacity: 0 }, 
          { scale: 1, opacity: 1, duration: 0.3, delay: 0.1 }
        );
      }
      
      // Close handlers
      const close = () => {
        if (typeof gsap !== 'undefined') {
          gsap.to(overlay, { 
            opacity: 0, 
            duration: 0.2, 
            onComplete: () => {
              overlay.remove();
              document.body.style.overflow = '';
            }
          });
        } else {
          overlay.remove();
          document.body.style.overflow = '';
        }
      };
      
      overlay.querySelector('.product-lightbox__close').addEventListener('click', close);
      overlay.querySelector('.product-lightbox__backdrop').addEventListener('click', close);
      overlay.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
      });
    }
  }

  /**
   * Initialize galleries on DOM ready
   */
  function init() {
    var ctx = new URLSearchParams(location.search).get('ctx');

    // Swap product title when arriving from a condition context
    if (ctx) {
      document.querySelectorAll('[data-ctx-title-' + ctx + ']').forEach(function(el) {
        el.textContent = el.getAttribute('data-ctx-title-' + ctx);
      });
    }

    var bracketRe = /\[[^\]]+\]/;

    document.querySelectorAll('.product-media-gallery').forEach(function(gallery) {
      var instance = new ProductMediaGallery(gallery);

      // No ctx: hide all non-[core] condition images so generic page stays clean
      if (!ctx) {
        var allThumbs = gallery.querySelectorAll('.product-media-gallery__thumbnail');
        var allItems = gallery.querySelectorAll('.product-media-gallery__carousel-item');
        allThumbs.forEach(function(thumb) {
          var img = thumb.querySelector('.product-media-gallery__thumbnail-image');
          var alt = (img && img.alt) ? img.alt : '';
          if (bracketRe.test(alt) && !alt.includes('[core]')) {
            thumb.style.display = 'none';
          }
        });
        allItems.forEach(function(item) {
          var img = item.querySelector('img');
          var alt = (img && img.alt) ? img.alt : '';
          if (bracketRe.test(alt) && !alt.includes('[core]')) {
            item.style.display = 'none';
          }
        });
        return;
      }

      var conditionTag = '[' + ctx + ']';

      // Determine which data-indices to hide (have a condition bracket that is neither [core] nor [ctx])
      var filteredIndices = new Set();
      var seenIdx = new Set();
      gallery.querySelectorAll('.product-media-gallery__thumbnail').forEach(function(thumb) {
        var dataIdx = parseInt(thumb.dataset.index);
        if (isNaN(dataIdx) || seenIdx.has(dataIdx)) return;
        seenIdx.add(dataIdx);
        var img = thumb.querySelector('.product-media-gallery__thumbnail-image');
        var alt = (img && img.alt) ? img.alt : '';
        var hasBracket = bracketRe.test(alt);
        var isCore = alt.includes('[core]');
        var isMatch = alt.includes(conditionTag);
        if (hasBracket && !isCore && !isMatch) {
          filteredIndices.add(dataIdx);
        }
      });

      // Hide filtered thumbnails
      gallery.querySelectorAll('.product-media-gallery__thumbnail').forEach(function(thumb) {
        if (filteredIndices.has(parseInt(thumb.dataset.index))) {
          thumb.style.display = 'none';
        }
      });

      // Hide filtered carousel items
      gallery.querySelectorAll('.product-media-gallery__carousel-item').forEach(function(item) {
        if (filteredIndices.has(parseInt(item.dataset.index))) {
          item.style.display = 'none';
        }
      });

      var totalMedia = seenIdx.size;
      var origGoToSlide = instance.goToSlide.bind(instance);

      // Skip filtered indices in goToSlide
      instance.goToSlide = function(index) {
        if (filteredIndices.has(index)) return;
        origGoToSlide(index);
      };

      // next/prev skip over filtered indices
      instance.next = function() {
        var idx = instance.currentIndex;
        for (var i = 0; i < totalMedia; i++) {
          idx = (idx + 1) % totalMedia;
          if (!filteredIndices.has(idx)) break;
        }
        origGoToSlide(idx);
      };
      instance.prev = function() {
        var idx = instance.currentIndex;
        for (var i = 0; i < totalMedia; i++) {
          idx = (idx - 1 + totalMedia) % totalMedia;
          if (!filteredIndices.has(idx)) break;
        }
        origGoToSlide(idx);
      };

      // Navigate to the first image matching [ctx]
      var carouselItems = gallery.querySelectorAll('.product-media-gallery__carousel-item');
      var carouselCount = carouselItems.length;
      var seen = new Set();
      var ctxSlideFound = false;
      gallery.querySelectorAll('.product-media-gallery__thumbnail').forEach(function(thumb) {
        if (ctxSlideFound) return;
        var idx = parseInt(thumb.dataset.index);
        if (isNaN(idx) || idx >= carouselCount || seen.has(idx)) return;
        seen.add(idx);
        var img = thumb.querySelector('.product-media-gallery__thumbnail-image');
        if (img && img.alt && img.alt.includes(conditionTag)) {
          origGoToSlide(idx);
          ctxSlideFound = true;
        }
      });
      // Fallback: search carousel items directly when no thumbnail matched
      if (!ctxSlideFound) {
        carouselItems.forEach(function(item) {
          if (ctxSlideFound) return;
          var img = item.querySelector('img');
          if (img && img.alt && img.alt.includes(conditionTag)) {
            origGoToSlide(parseInt(item.dataset.index));
            ctxSlideFound = true;
          }
        });
      }
    });
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-initialize on Shopify section refresh
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const gallery = event.target.querySelector('.product-media-gallery');
      if (gallery) {
        new ProductMediaGallery(gallery);
      }
    });
  }
  
  // Expose for external use
  window.ProductMediaGallery = ProductMediaGallery;
  window.ProductVariantSelector = ProductVariantSelector;
})();

/**
 * Add lightbox styles dynamically
 */
(function() {
  const style = document.createElement('style');
  style.textContent = `
    .product-lightbox {
      position: fixed;
      inset: 0;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .product-lightbox__backdrop {
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.9);
    }
    
    .product-lightbox__content {
      position: relative;
      max-width: 90vw;
      max-height: 90vh;
    }
    
    .product-lightbox__image {
      max-width: 100%;
      max-height: 90vh;
      object-fit: contain;
    }
    
    .product-lightbox__close {
      position: absolute;
      top: -40px;
      right: 0;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      color: white;
      cursor: pointer;
      transition: opacity 0.2s;
    }
    
    .product-lightbox__close:hover {
      opacity: 0.7;
    }
  `;
  document.head.appendChild(style);
})();

// Dynamic title colour update: when a colour variant is selected, replace the
// "(Colour)" suffix in the product title h1 with the newly selected colour.
// Purely visual — no Shopify data is modified.
(function() {
  'use strict';
  var COLOR_OPTION_RE = /^col(o|ou)r$/i;
  var TITLE_COLOR_RE = /\s*\(([^)]+)\)\s*$/;

  function findColorValue(selectedOptions) {
    if (!selectedOptions) return null;
    var keys = Object.keys(selectedOptions);
    for (var i = 0; i < keys.length; i++) {
      if (COLOR_OPTION_RE.test(keys[i])) return selectedOptions[keys[i]];
    }
    return null;
  }

  function displayColor(name) {
    if (!name) return name;
    return name.replace(/Charcoal Gr[ea]y/gi, 'Dark Brown');
  }

  window.addEventListener('variant:changed', function(e) {
    var color = findColorValue(e.detail && e.detail.selectedOptions);
    if (!color) return;
    var label = displayColor(color);
    document.querySelectorAll('.product-title-block__title').forEach(function(el) {
      var current = el.textContent.trim();
      if (TITLE_COLOR_RE.test(current)) {
        el.textContent = current.replace(TITLE_COLOR_RE, ' (' + label + ')');
      }
    });
  });
})();
